import taskCreation from './taskCreation';
import taskDetail from './taskDetail';
import taskImport from './taskImport';
import taskList from './taskList';
import taskDownload from './taskDownload';

export default {
  taskDetail,
  taskCreation,
  taskImport,
  taskList,
  taskDownload,
};
